import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BranchingQueryDefinition, getParentEdgeTypeId } from '@iotv/datamodel';
import { ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
import { Alert, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { ConsumerDao } from '../../../data/ConsumerDAO';
import { AdjacentType } from '../../../types';
import { Listerlizer } from '../../factories/Listerlizer/Listerlizer';
import { PartnerViewDefinition } from '../../Partner/viewDefinitions';
import { GroupViewDefinition } from '../Devices/DeviceGatewayGroupViewSubParts';
/** A listerlizer that finds Partner -> Group links.
 * The customer selection is not bounded at all, you can link any partner in the system to this group */
export const EntityGroupPartnerTab = ({ viewObject, userFunctions, transactionFunctions, columnVisibilityReferences, applicationData, }) => {
    /** Region Control */
    /** Query for Apex Partner Group (root for query to get linkable partners */
    const [apexPartnerGroup, setApexPartnerGroup] = useState(applicationData?.getNodesOfType('Group')?.find((p) => p.name === 'Apex Partners') ?? undefined);
    const [apexPartnerErrorDisplay, setApexPartnerErrorDisplay] = useState(undefined);
    useEffect(() => {
        if (apexPartnerGroup !== undefined)
            return;
        ConsumerDao.getApexGroupsOfSupportedType('Partner').then((apex_partner_res) => {
            if (apex_partner_res.err) {
                console.error(apex_partner_res.err);
                setApexPartnerErrorDisplay('An error occured finding partners. Error: apex_partner_res.err.message');
                return;
            }
            if (!apex_partner_res.data) {
                console.warn('EntityGroupPartnerTab', 'getApexGroupsOfSupportedType returned no err and no data. Have you pushed ConsumerDataAPI since July 15 2025?', apex_partner_res);
                setApexPartnerErrorDisplay('Could not find partners, please open developer console for more details.');
                return;
            }
            const apexPartnerGroup = apex_partner_res.data.find((p) => p.name === 'Apex Partners');
            if (!apexPartnerGroup) {
                console.warn('EntityGroupPartnerTab', 'failed to fetch Apex Partners, have you deployed base data since July 15 2025?', apex_partner_res);
                setApexPartnerErrorDisplay('Could not find partners, please open developer console for more details.');
                return;
            }
            setApexPartnerGroup(apexPartnerGroup);
        });
    }, [apexPartnerGroup]);
    /** Direct Links */
    const props = applicationData
        ? {
            autoQuery: false,
            adjacentFilter: {
                objectType: 'Partner',
                adjacentType: AdjacentType.PARENT,
                edgeFilter: {
                    edgeTypeId: getParentEdgeTypeId('Group', 'Partner'),
                    edgeAttributeFilters: [
                        {
                            setOperation: LogicalOperatorType.AND,
                            filters: [{ key: 'partnerViaRegion', predicate: ComparisonType.NOT_EQUALS, value: true }],
                        },
                    ],
                },
                sourceObjectType: 'Partner',
            },
            viewObject,
            userFunctions,
            transactionFunctions,
            viewDefinition: GroupViewDefinition,
            contextObject: viewObject.matchedPrimary,
            linkableItemsViewDefinition: PartnerViewDefinition,
            searchRootObjects: apexPartnerGroup ? [apexPartnerGroup] : undefined,
            linkableItemsResultFilter: {
                objectTypeId: 'Partner',
                adjacencyType: AdjacentType.PARENT,
            },
            linkableItemsBranchingQueryDefinition: new BranchingQueryDefinition({
                id: 'partnerGroupToPartner',
                path: [{ objectTypeId: 'Partner', edgeTypeId: getParentEdgeTypeId('Partner', 'Group'), adjacencyType: AdjacentType.CHILD }],
                subQueries: [],
            }),
            columnVisibilityReferences,
            applicationData,
        }
        : undefined;
    // TODO: make it so we display the names of partners connected to parent groups of this group
    return (_jsxs(Stack, { spacing: 1, children: [apexPartnerErrorDisplay && _jsx(Alert, { severity: "error", children: apexPartnerErrorDisplay }), apexPartnerGroup && props && _jsx(Listerlizer, { ...props })] }));
};
